import React, { Fragment, useContext, useEffect, useState, useRef, memo, useCallback, useReducer } from "react";
// Provider
import { AppContext, SET_APP_SHARHSPLIST,SET_APP_SETINFO, SET_APP_ALL, socketManager, SocketCommand } from "../../components/AppProvider";

// Utils
import { _O } from "../../modules/utils";

// UI
import { Container, DateLayer, DateTimeLayer, openLayerFn, closeLayerFn, pickerStart, AlertPopup, InputPopup } from "../Layout";

import { AlertLayer, ConfirmLayer } from "../../components/UI/Dialog";
import { ItemOnOffLayer, ItemOnOffLayerH } from "./Main.Layer";
import { PostApi1913, PostApi1914, PostApi1930 } from "../../modules/network/padoPost";
import { HospitalList, HospitalList2, Nothing, request273, request274, request278, requestHsptList, SearchHospital } from "../Reservation/Surround";
import { VisitReceipt } from "../Reservation/Reservation.Layers";
import { mapLayer, MapView } from "../common/Modal/NaverMap";
import { reLogin } from "../common/AutoLogin/AutoLogin";
import { PostApi1916 } from './../../modules/network/padoPost';
import { useInView } from 'react-intersection-observer';

export const request1914 = (userinfo ,cfg ,phonecfg, dispatch ,setColumn, setValue, hpKey, ptntNo, handleConfirm, spclParam) => {
    PostApi1914(userinfo, cfg, phonecfg, setColumn, setValue, hpKey, ptntNo)
    .then(res => {
        if(res.resultMsg === 'SUCCESS') {
            if(ptntNo && ptntNo != "") {
                request1930(userinfo, cfg, phonecfg, "O", ptntNo, handleConfirm);
            }
            request1913(userinfo, cfg, phonecfg, dispatch);
            if(spclParam) {
                _O.Open('/pmr/proofRecipt');
            } else {
                _O.Open('/mp/settings/data');
            }
        } else if(res.resultMsg === "LOGOUT") {
            openLayerFn($(".alert-layer-logout"));
        } else {
            handleConfirm("", "병원 등록에 실패 하였습니다.");
        }
    })
    .catch(err => {
        console.log(err);
    });
};

export const request1916 = (userinfo, cfg, phonecfg, dispatch, hpKey) => {
    // PostApi1916(userinfo, cfg, phonecfg, 'hpKey', "Y", hpKey, '')
    PostApi1916(userinfo, cfg, phonecfg, hpKey, "I", "", userinfo)
    .then(res => {
        if(res.resultMsg === 'SUCC') {
            request1913(userinfo, cfg, phonecfg, dispatch);
            _O.Open('/pmr/proofRecipt');
        } else if(res.resultMsg === "LOGOUT") {
            openLayerFn($(".alert-layer-logout"));
        } else {
            // handleConfirm("", "병원 등록에 실패 하였습니다.");
            handleConfirm("", "병원 등록에 실패 하였습니다.");
        }
    })
    .catch(err => {
        console.log(err);
    });
}

export const request1930 = (userinfo, cfg, phonecfg, reqType, attctNo, handleConfirm) => {
    PostApi1930(userinfo, cfg, phonecfg, reqType, attctNo)
    .then(res => {
        if(res.resultMsg === 'SUCCESS') {
            handleConfirm("", "연동에 성공하였습니다.")
        } else if(res.resultMsg === "LOGOUT") {
            handleConfirm("", "다른 기기에 로그인 한 계정입니다.")
        }else {
            handleConfirm("", "인증번호 등록에 실패하였습니다.");
        }
    })
    .catch(err => {
        console.log(err);
    });
}

export const request1913 = (userinfo, cfg, phonecfg, dispatch) => {
    PostApi1913(userinfo, cfg, phonecfg)
    .then(res => {
        if(res.resultMsg === 'SUCCESS') {
            let data = res.result;
            dispatch({type: SET_APP_ALL, data: data});
        } else {
            console.log("LOGOUT!!!");
        }
    })
    .catch(err => {
        console.log(err);
    });
};

export default (props) => {
    const {userinfo, cfg, phonecfg, dispatch, auth} = useContext(AppContext);

    // 다이얼로그 [[
    const [dialog, setDialog] = useState({
        title: '',
        msg: '',
    })

    const [hpKey, setHpKey] = useState();
    const [hpName, setHpName] = useState();
    // const [ search, setSearch ] = useState(false);
    const [ search, setSearch ] = useState(userinfo.app.sharHsptList.length > 0 ? false : true);

    const [ hpLat, setHpLat ] = useState('');
    const [ hpLon, setHpLon ] = useState('');
    const [ selectHpNm, setSelectHpNm ] = useState('');
    const [ locationInfo, setLocationInfo ] = useState({});

    const handleConfirm = (title, msg) => {
        setDialog({
            title: title,
            msg: msg,
        })

        openLayerFn($(".alert-layer"));
    }

    const handleCancelCB = () => {
        // closeLayerFn($(".alert-layer"));
    }

    const handleConfirmCB = () => {
        // closeLayerFn($(".alert-layer"));
    }

    const handleWithdrawalConfirm = (title, msg) => {
        setDialog({
            title: title,
            msg: msg,
        })

        openLayerFn($(".confirm-layer"));
    }

    const handleWithdrawalCancelCB = () => {
        closeLayerFn($(".confirm-layer"));
    }

    const handleWithdrawalConfirmCB = () => {
        request1914(userinfo, cfg, phonecfg, dispatch, 'hpKey', 'Y', hpKey);
        setSearch(false);
        $("#searchHpNm").val("");
        closeLayerFn($(".confirm-layer"));
    }

    // 다이얼로그 ]]
    let userinfo2 = reLogin(auth, userinfo, dispatch);

    useEffect(() => {
        request1913(userinfo2, cfg, phonecfg, dispatch);
    }, []);

    useEffect(() => {
        // click 이벤트 제거
        $(".onoff-btn").off("click");

        // click 이벤트 재설정
        $(".onoff-btn").click(function(){
            if( $(this).hasClass("on") ){
                $(this).removeClass("on");
                $(this).addClass("off");
            }else if( $(this).hasClass("off") ){
                $(this).addClass("on");
                $(this).removeClass("off");
            }
            let  key    = $(this).attr("id");
            let  data   = $(this).hasClass("off")?'N':'Y';
            let  hpkey  = '';
            
            if ($(this).attr("op") === 'H') {
                dispatch({type: SET_APP_SHARHSPLIST,key:key,data: data});
                hpkey = key;
                key = 'hpKey';
            }
            else {
                dispatch({type: SET_APP_SETINFO,key:key,data: data});
            }
            request1914(userinfo, cfg, phonecfg, dispatch, key, data, hpkey, '', handleConfirm);
        });
        
    }, [userinfo.app, search, phonecfg]);

    return (
        <Fragment>

            <Container Title={ '개인데이터 공유 및 다운로드' } dark={'dark'} isMain={false} goToUrl="/mp/settings/0" /*bottom={list.length === 0 ? <Bottom /> : null}*/ >
                <div className="contents">
                    <div className="sub-contents">
                        <div className="device-link-contain type3">

                            <IndividualDataDownload />

                            <IndividualDataShare setHpKey={setHpKey} setHpName={setHpName} search={search} setSearch={setSearch} handleWithdrawalConfirm={handleWithdrawalConfirm} setHpLat={setHpLat} setHpLon={setHpLon} setSelectHpNm={setSelectHpNm} setLocationInfo={setLocationInfo} />

                        </div>
                    </div>
                </div>
            </Container>

            <AlertLayer
                priv="priv"
                title={dialog.title}
                msg={dialog.msg}
                handleConfirmCB={handleConfirmCB}
            />

            <ConfirmLayer
                priv="priv"
                title={dialog.title}
                msg={dialog.msg}
                handleCancelCB={handleWithdrawalCancelCB}
                handleConfirmCB={handleWithdrawalConfirmCB}
            />

            <InputPopup color="PURPLE" hpKey={hpKey} hpName={hpName} handleConfirm={handleConfirm}/>
            <MapView hpLat={hpLat} hpLon={hpLon} selectHpNm={selectHpNm} locationInfo={locationInfo} popupType={"HSPT"} />

        </Fragment>
    );
};

const IndividualDataDownload = (props) => {
    const {userinfo} = useContext(AppContext);
    return (
        <Fragment>
            <div>
                <p className="t-txt">
                    본 서비스에서 사용된 개인 데이터는 본인의 휴대전화에 다운로드 됩니다.<br />
                    또한, 이용자의 동의하에 서비스를 사용하는 병원에서 개인 데이터를 공유할수 있습니다.
                </p>
            </div>
            <div>
                <div className="round-list">
                    <ItemOnOffLayer isGray={true} name='개인데이터 다운로드' id = 'psnlDnYn'  op = 'O'  isOn={(userinfo.app && userinfo.app.setInfo && userinfo.app.setInfo.psnlDnYn ==='N')?false:true}/>
                </div>
            </div>
        </Fragment>
    )
}
const IndividualDataShare = (props) => {
    const {userinfo, cfg, phonecfg} = useContext(AppContext);
    const { setHpKey, setHpName, handleWithdrawalConfirm, search, setSearch, setHpLat, setHpLon, setSelectHpNm, setLocationInfo } = props;
    // const [ search, setSearch ] = useState(false);

    // 선택된 병원키
    // const [ hpKey, setHpKey ] = useState('');    
    const [ resrvType, setResrvType ] = useState('0');    // 방문/전화 팝업 타입
    const [ list, setList ] = useState(null);

    const styleLeftGray = {
        "width":"45%"
        , "float":"left"
        , "textAlign":"center"
    }
    
    const styleRightGray = {
        "width":"45%"
        , "float":"right"
        , "textAlign":"center"
    }
    
    const styleLeftPurple = {
        "width":"45%"
        , "float":"left"
        , "textAlign":"center"
        , "backgroundColor":"#B2BEE5"
        , "color":"#fff"
    }
    
    const styleRightPurple = {
        "width":"45%"
        , "float":"right"
        , "textAlign":"center"
        , "backgroundColor":"#B2BEE5"
        , "color":"#fff"
    }

    const styleBtnSearch = {
        "position":"absolute"
        , "right":0
        , "top":0
        , "width":"50px"
        , "height":"100%"
        , "border":"0px"
    }

    const onClickHpNm = (searchType) => {
        // request278(userinfo, cfg, phonecfg, searchType, $("#searchHpNm").val(), '', setList);
        requestHsptList(userinfo, cfg, phonecfg, "A", $("#searchHpNm").val(), setList);
    }

    const onClickHpNmEnter = (searchType) => {
        // request278(userinfo, cfg, phonecfg, searchType, $("#searchHpNm").val(), '', setList);

        if(window.event.keyCode == 13) {
            requestHsptList(userinfo, cfg, phonecfg, "A", $("#searchHpNm").val(), setList);
        }
    }

    // useEffect(() => {
    //     // request278(userinfo, cfg, phonecfg, "", "", "", setList);
    //     requestHsptList(userinfo, cfg, phonecfg, "A", "", setList);
    // }, [search]);

    return (
        <div>
            <div className="round-list">

                <ItemOnOffLayer isGray={true} name='개인데이터 공유'  id = 'psnlDataSharYn'  op = 'O' isOn={(userinfo.app && userinfo.app.setInfo && userinfo.app.setInfo.psnlDataSharYn ==='N')?false:true}/>
                
                <div>
                    자주가는 병원을 연결하면 과거 진료기록을 통해 진료를 받을 수 있습니다.
                </div>

                <div>
                    <div className="gray-r-box" style={search ? styleLeftGray : styleLeftPurple} onClick={()=>setSearch(false)}>연동병원</div>
                    <div className="gray-r-box" style={search ? styleRightPurple : styleRightGray} onClick={()=>setSearch(true)}>병원검색</div>
                </div>


                {!search 
                    ?   (userinfo.app && userinfo.app.sharHsptList)
                        ?   userinfo.app.sharHsptList.map((item, i) => {
                                return (
                                            // <ItemOnOffLayer id = {item.hpKey} key = {item.hpKey} name= {item.hsptNm} op = 'H' isOn={(item.sharYn==='N')?false:true}/>
                                            <ItemOnOffLayerH id = {item.hpKey} key = {item.hpKey} name= {item.hsptNm} address2 = {item.address2} op = 'H' isOn={(item.sharYn==='N')?false:true} ptntNo={item.ptntNo} setHpKey={setHpKey} setHpName={setHpName} />
                                        );
                            })
                        :   <div><p>등록된 병원이 없습니다</p></div>
                    :   <div className="device-link-contain type3">
                            <div className="pr-section">
                                <div className="pharmacy-search hos">
                                    <div>
                                        <input type="text" id="searchHpNm" className="textbox" onKeyUp={()=>onClickHpNmEnter("HPNM")} placeholder="병원명을 입력해주세요." />
                                        <a onClick={() => onClickHpNm("HPNM")} style={styleBtnSearch}></a>
                                    </div>
                                </div>
                            </div>
                            
                            {
                                (list && list.length > 0) &&
                                    <div style={{
                                        fontSize:"12px"
                                        , color:"#B2BEE5"
                                        , float:"right"
                                        , marginTop:"10px"
                                    }}>
                                        거리순
                                    </div>
                            }

                            <HospitalListShare
                                list={list}
                                setSelectHpNm={setSelectHpNm}
                                setHpLat={setHpLat}
                                setHpLon={setHpLon}
                                setHpKey={setHpKey}
                                addMode="addMode"
                                setLocationInfo={setLocationInfo}
                                handleWithdrawalConfirm={handleWithdrawalConfirm}
                            />
                        </div>
                }

                {/* 병원추가등록 버튼 */}
                {/* <div className="rd-box-empty">
                    <i onClick={()=>_O.Open('/mp/settings/data/hspt')}></i>
                </div> */}

            </div>
        </div>
    )
}

export const AddHspt = (props) => {
    const { userinfo, cfg, phonecfg, auth, dispatch } = useContext(AppContext);

    const [ selectHpNm, setSelectHpNm ] = useState('');
    const [ hpLat, setHpLat ] = useState('');
    const [ hpLon, setHpLon ] = useState('');
    const [ hpKey, setHpKey ] = useState('');    // 선택된 병원키
    const [ resrvType, setResrvType ] = useState('0');    // 방문/전화 팝업 타입
    // const [ list, setList ] = useState(null);
    const [ list, setList ] = useState([]);

    const [ callSTime, setCallSTime ] = useState();
    const [ callETime, setCallETime ] = useState();

    const [ locationInfo, setLocationInfo ] = useState({});

    const [doctorList, setDoctorList] = useState(null);

    const [dialog, setDialog] = useState({
        title: '',
        msg: '',
    })

    const handleConfirm = (title, msg) => {
        setDialog({
            title: title,
            msg: msg,
        })

        openLayerFn($(".alert-layer"));
    }


    const onClickHpNm = (searchType) => {
        resetPaging();
        request278(userinfo, cfg, phonecfg, searchType, $("#searchHpNm").val(), $("#searchHpAddr").val(), setList);
    }

    useEffect(() => {
        request278(userinfo, cfg, phonecfg, "", "", "", setList, resetPaging);
    }, []);

    const { ref, inView } = useInView();

    const [lastIndex, setLastIndex] = useState(1);
    const [displayList, setDisplayList] = useState([]);
    const [deleteState, setDeleteState] = useState(true);
    const [resetState, setResetState] = useState(true);

    const CPP = 20;

    const resetPaging = () => {
        setList([]);
        setDisplayList([]);
        setLastIndex(1);
        setResetState(true);
    }

    useEffect(() => {
        const tList = list && Array.isArray(list) &&
        list.filter(
            (i, index) => index >= (lastIndex - 1) * CPP && index < lastIndex * CPP
        );

        if(resetState) {
            setDisplayList(tList);
            setResetState(false);
        } else {
            setDisplayList([...(displayList ?? []), ...(tList ?? [])]);
        }
    }, [lastIndex, list]);

    useEffect(() => {
        if (!list || !Array.isArray(list)){
            resetPaging();
            // return;
        } else if (inView && lastIndex * CPP < list.length) {
            if(resetState === false) {
                setLastIndex(lastIndex + 1);
            } else {
                setLastIndex(1);
            }
        }
    }, [inView]);

    return(
        <Fragment>
            <Container Title={ '병원등록' } dark={'dark'} isMain={false} /*bottom={list.length === 0 ? <Bottom /> : null}*/ >
                <div className="contents">
                    <div className="sub-contents">
                        <div className="device-link-contain type3">

                            <SearchHospital onClickHpNm = {onClickHpNm} />

                            {/* list, setDoctorList, setHpKey, setResrvType, setSelectHpNm, setHpLat, setHpLon, setCallSTime, setCallETime */}
                            <HospitalList2  
                                list={displayList} 
                                setSelectHpNm={setSelectHpNm} 
                                setHpLat={setHpLat}  
                                setHpLon={setHpLon} 
                                setHpKey={setHpKey}
                                addMode="addMode"
                                setLocationInfo={setLocationInfo}

                                spclParam={props.match.params.menu}
                            />
                            <div ref={ref} />
                        </div>
                    </div>
                </div>
            </Container>

            <VisitReceipt doctorList={doctorList} hpKey={hpKey} resrvType={resrvType} callSTime={callSTime} callETime={callETime} />
            <MapView hpLat={hpLat} hpLon={hpLon} selectHpNm={selectHpNm} locationInfo={locationInfo} />
            <AlertPopup color="PURPLE" />
            <InputPopup color="PURPLE" hpKey={hpKey} handleConfirm={handleConfirm} />
            {/* <ConfirmLayer
                title={dialog.title}
                msg={dialog.msg}
                handleConfirmCB={handleConfirmCB}
                handleCancelCB={handleCancelCB}
            /> */}

        </Fragment>
    );
}

export const HospitalListShare = (props) => {
    const { userinfo, cfg, phonecfg, dispatch } = useContext(AppContext);
    
    const { list, handleWithdrawalConfirm, setHpKey, setHpLat, setHpLon, setSelectHpNm, setLocationInfo } = props;

    // 병원등록 API
    const addHospital = (hpKey) => {
        request1914(userinfo, cfg, phonecfg, dispatch, 'hpKey', 'Y', hpKey);
    }

    const styleA = {
        "border":"0px"
    }

    const styleBtnReceipt = {
        width:"100%"
        , border:"0px"
        , backgroundSize:"0px"
    }

    const onClickCheckI = (hpName, hpKey) => {
        setHpKey(hpKey);
        setHpLat();
        setHpLon();
        setSelectHpNm();
        handleWithdrawalConfirm('', hpName+'을(를) 등록하시겠습니까?');
    };

    return (
      <div
        className="linebox-info-list"
        style={{ marginTop: "20px", paddingBottom: "120px" }}>
        <ul>
          {list != null && list.length > 0 ? (
            list.map((m, i) => (
              <li key={"aaa" + i}>
                <div className="line-box rep">
                  <div className="addr">
                    {/* 병원정보영역 */}
                    <div style={{ width: "82%" }}>
                      <span>
                        {m.hsptNm}({m.address2})
                      </span>
                      <p>
                        {m.address3} {m.address4}
                      </p>
                      <p>
                        Tel :{" "}
                        {m.phone
                          .toString()
                          .replace(
                            /(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/,
                            "$1-$2-$3"
                          )}
                      </p>
                    </div>
                    {/* 병원정보영역 */}

                    {/* 체크박스 영역 */}
                    {m.addYn === "N" && (
                      <label
                        style={{
                          position: "absolute",
                          width: "40px",
                          height: "40px",
                          right: 0,
                          top: "50%",
                          transform: "translateY(-50%)",
                        }}
                        onClick={() => onClickCheckI(m.hsptNm, m.hsptKey)}>
                        <input type="radio" style={{ display: "none" }} />
                        <i
                          className="styleCheckI"
                          style={{ width: "40px", height: "40px" }}></i>
                      </label>
                    )}
                    {/* 체크박스 영역 */}
                  </div>

                  {/* 하단버튼 영역 */}
                  <div className="thr-btns">
                    <a
                      onClick={() => mapLayer(phonecfg, setLocationInfo, m)}
                      className="location btn-open-map"
                      style={styleA}></a>

                    {m.addYn === "N" ? (
                      <a
                        className="hf btn-open-visit-receipt"
                        style={styleBtnReceipt}
                        onClick={() => addHospital(m.hsptKey)}>
                        <text style={{ float: "left" }}>
                          병원등록
                          <em style={{ fontSize: "12px", color: "#B2BEE5" }}>
                            {" "}
                            가능
                          </em>
                        </text>
                        <text
                          style={{
                            fontSize: "12px",
                            float: "right",
                            color: "#B2BEE5",
                          }}>
                          현재위치 {m.distance} km
                        </text>
                      </a>
                    ) : (
                      <a
                        className="hf btn-open-visit-receipt"
                        style={styleBtnReceipt}>
                        <text style={{ float: "left" }}>병원연결완료</text>
                        <text
                          style={{
                            fontSize: "12px",
                            float: "right",
                            color: "#B2BEE5",
                          }}>
                          현재위치 {m.distance} km
                        </text>
                      </a>
                    )}
                  </div>
                  {/* 하단버튼 영역 */}
                </div>
              </li>
            ))
          ) : (
            <Nothing list={list} />
          )}
        </ul>
      </div>
    );
}